import PostEditPage from './post-edit-page';
import PostEditModalLoader from './post-edit-modal-loader';
import forDevice from '../../hoc/for-device';

const PostEditorPageOrModal = forDevice(PostEditModalLoader, PostEditPage);

export default PostEditorPageOrModal;
